import { useEffect } from 'react';

import { SCAN_EVENT_QUEUE } from '../constants/scanEventQueue.const';
import { createScanContext } from '../utils/createScanContext.util';
import { createScanEventProcessor } from '../utils/createScanEventProcessor.util';
import { handleScanEvent } from '../utils/handleScanEvent.util';

/**
 * Mounts the sole consumer of the scan event queue.
 */
export const useScanEventProcessor = () => {
  useEffect(() => {
    const processor = createScanEventProcessor({
      getScanContext: createScanContext,
      handleScanEvent,
      queue: SCAN_EVENT_QUEUE,
    });

    return SCAN_EVENT_QUEUE.subscribe(processor.process);
  }, []);
};
